// import { grantImportFileAccessUrl } from "@root/graphql/Imports.gql";
import { easyMutate } from "@root/lib/utils";

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    // async grantImportFileAccessUrl({ rootState }: any, importNo) {
    //   let {
    //     data: {
    //       api: { url }
    //     }
    //   } = await rootState.gql.query({
    //     query: grantImportFileAccessUrl,
    //     variables: {
    //       importNo
    //     }
    //   });
    //   return url;
    // }
  },
  mutations: {
    easyMutate
  }
};
